import React from 'react';

import UI from './ProductBox.ui';

export default function ProductBox(props) {
  return (
    <UI
      props={props.items ?? {}}
      onProductClick={props.onProductClick}
      name={props.name}
      defaultPlanName={props.defaultPlanName}
      selected={props.selected}
      setListCompare={props.setListCompare}
      listCompare={props.listCompare}
      categorySlug={props.categorySlug}
      categoryName={props.categoryName}
      categoryId={props.categoryId}
      resetCatalog={props.resetCatalog}
      setShowModalComparator={props.setShowModalComparator}
      categorySlugSearch={props.categorySlugSearch}
      showESimIndicator={props?.showESimIndicator ?? false}
      esimIndicator={props?.esimIndicator ?? null}
    />
  );
}
